import { render } from "./NumberView.vue?vue&type=template&id=c467596c&scoped=true"
import script from "./NumberView.vue?vue&type=script&lang=js"
export * from "./NumberView.vue?vue&type=script&lang=js"

import "./NumberView.vue?vue&type=style&index=0&id=c467596c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c467596c"]])

export default __exports__